import { Deserializable } from '../protocols/deserializable';
import { MemberOnboardingProgressTypeEnum } from './enum/member-onboarding-progress-type.enum';

export class MemberOnboardingProgress implements Deserializable {
  public progress: number = 0;
  public isSelfEnrolled: boolean = false;
  public steps: MemberOnboardingProgressStep[] = [];

  public onDeserialize(): void {
    const deserialize = window?.injector?.Deserialize;
    this.steps = deserialize?.arrayOf(MemberOnboardingProgressStep, this.steps);
    this.steps.sort((a, b) => a.id - b.id);
  }
}

export class MemberOnboardingProgressStep implements Deserializable {
  public id!: MemberOnboardingProgressTypeEnum;
  public completed: boolean = false;
  public name!: string;

  public onDeserialize(): void {}
}
